module.exports = "https://www.gc-pro.gnp.com.mx/083a4d8ba55cd467b880ee36379013db.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/acceso-compartido/01.png
// module id = 995
// module chunks = 0 1